var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalEllipsis(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_819_1870",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: ""
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_819_1870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00033 8.33333C4.77116 8.33333 4.57498 8.25174 4.41178 8.08854C4.24859 7.92535 4.16699 7.72917 4.16699 7.5C4.16699 7.27083 4.24859 7.07465 4.41178 6.91146C4.57498 6.74826 4.77116 6.66667 5.00033 6.66667C5.22949 6.66667 5.42567 6.74826 5.58887 6.91146C5.75206 7.07465 5.83366 7.27083 5.83366 7.5C5.83366 7.72917 5.75206 7.92535 5.58887 8.08854C5.42567 8.25174 5.22949 8.33333 5.00033 8.33333ZM5.00033 5.83333C4.77116 5.83333 4.57498 5.75174 4.41178 5.58854C4.24859 5.42535 4.16699 5.22917 4.16699 5C4.16699 4.77083 4.24859 4.57465 4.41178 4.41146C4.57498 4.24826 4.77116 4.16667 5.00033 4.16667C5.22949 4.16667 5.42567 4.24826 5.58887 4.41146C5.75206 4.57465 5.83366 4.77083 5.83366 5C5.83366 5.22917 5.75206 5.42535 5.58887 5.58854C5.42567 5.75174 5.22949 5.83333 5.00033 5.83333ZM5.00033 3.33333C4.77116 3.33333 4.57498 3.25174 4.41178 3.08854C4.24859 2.92535 4.16699 2.72917 4.16699 2.5C4.16699 2.27083 4.24859 2.07465 4.41178 1.91146C4.57498 1.74826 4.77116 1.66667 5.00033 1.66667C5.22949 1.66667 5.42567 1.74826 5.58887 1.91146C5.75206 2.07465 5.83366 2.27083 5.83366 2.5C5.83366 2.72917 5.75206 2.92535 5.58887 3.08854C5.42567 3.25174 5.22949 3.33333 5.00033 3.33333Z",
    fill: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalEllipsis);
export default __webpack_public_path__ + "static/media/verticalEllipsis.210f13c43c3b1e5fd069a52210e40775.svg";
export { ForwardRef as ReactComponent };